export const quotations = {
  alerts: {
    errorDuplicateEntryNumber: 'Je hebt offertenummer “{{entryNumber}}” al eens gebruikt.',
    missingFcFiles_one: 'De pdf voor deze offerte is niet terug te vinden.',
    missingFcFiles_other: 'De pdf’s voor deze offertes zijn niet terug te vinden.',
    successCreated: 'Je offerte is aangemaakt.',
    successDeleted: 'Je concept is verwijderd.',
    successUpdated: 'Je offerte is bewerkt.',
  },
  breadcrumb: {
    create: 'Offertedetails',
    noTitle: 'Geen titel',
    overview: 'Offertes',
  },
  clientAccept: {
    card: {
      button: 'Keur offerte goed',
      description: {
        accept: 'Ga je akkoord met de offerte van {{user}}? Keur deze dan goed via onderstaande knop.',
        accepted: 'De offerte werd aangeduid als goedgekeurd.',
        declined: 'De offerte werd aangeduid als afgewezen.',
        expired: 'De offerte is vervallen en kan niet meer goedgekeurd worden.',
      },
      title: 'Offerte van {{user}}',
    },
    preview: {
      assignment: {
        title: 'Opdracht',
      },
      client: 'Gegevens klant',
      conditions: {
        description: 'Raadpleeg de algemene voorwaarden van deze offerte',
        title: 'Algemene voorwaarden',
      },
      createdBy: 'Deze offerte werd opgemaakt en verstuurd door',
      description: 'Beschrijving',
      expirationDate: 'Geldig tot',
      freelancer: 'Uitvoerder opdracht',
      introduction: 'Introductie',
      specialConditions: 'Bijzondere voorwaarden',
      title: 'Titel',
    },
  },
  createEdit: {
    assignment: {
      description: 'Beschrijf kort wat je opdracht zoal inhoudt.',
      title: 'Opdracht',
    },
    attachments: {
      description: 'Voeg eventuele documenten toe aan deze offerte.',
      error: {
        delete: 'Er ging iets mis bij het verwijderen van de bijlage.',
      },
      title: 'E-mail en bijlagen',
    },
    basicInfo: {
      description: 'Alle basisinformatie van je offerte.',
      title: 'Basisinformatie',
    },
    blocker: {
      message: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je offerte zijn niet opgeslagen.',
    },
    confirmation: {
      description:
        'Ben je zeker dat je de offerte wilt versturen? De offerte wordt niet nagekeken, deze wordt meteen verstuurd naar je klant.',
      submit: {
        create: 'Ja, offerte versturen',
        edit: 'Ja, offerte versturen',
      },
      title: 'Je offerte wordt verstuurd',
    },
    error: {
      title: 'Fout bij het laden van je offerte.',
    },
    lines: {
      description: 'Lijst hier de producten en/of diensten op die je aanbiedt.',
      title: 'Offertelijnen',
    },
    preview: 'Voorbeeld',
    submit: {
      create: 'Offerte versturen',
      edit: 'Offerte bewerken',
      saveConcept: 'Opslaan en verlaten',
      saveSend: 'Opslaan & versturen',
    },
    title: {
      create: 'Concept offerte',
      edit: 'Bewerk offerte',
    },
  },
  fields: {
    attachment: {
      label: 'Bijlage',
    },
    description: {
      label: 'Beschrijving',
    },
    entryNumber: {
      label: 'Offertenummer',
      last: 'Je laatste offerte heeft als nummer <0>{{entryNumber}}</0>.',
      placeholder: 'Offertenummer',
    },
    expirationDate: {
      label: 'Vervaldatum',
    },
    introduction: {
      label: 'Introductie',
    },
    mail: {
      default:
        '<p>\nDag #CLIENTNAME#,<br/><br/>\n\n#FREELANCERFIRSTNAME# heeft een offerte voor je opgemaakt. Kijk je deze even na?<br/><br/>\n\nHierzo: #QUOTATIONLINK#.<br/><br/>\n\nZodra jij je goedkeuring geeft, kan #FREELANCERFIRSTNAME# aan de slag.\n</p>',
      label: 'E-mail',
    },
  },
  header: {
    actionBlock: {
      button: 'Offerte aanmaken',
    },
    title: 'Offertes',
  },
  overview: {
    allowModal: {
      description: 'Ben je zeker dat je de offerte wilt markeren als goedgekeurd?',
      title: 'Markeer offerte als goedgekeurd',
    },
    columns: {
      client: 'Klant',
      date: 'Offertedatum',
      days: 'dagen',
      entryNumber: 'Offerte',
      status: {
        options: {
          Approved: 'Goedgekeurd',
          Draft: 'Concept',
          Expired: 'Vervallen',
          Rejected: 'Afgewezen',
          Sent: 'Verstuurd',
        },
        title: 'Status',
      },
      total: 'Totaal (excl. btw)',
    },
    declineModal: {
      description: 'Ben je zeker dat je de offerte wilt markeren als afgewezen?',
      title: 'Markeer offerte als afgewezen',
    },
    error: {
      title: 'Fout bij het laden van je offertes.',
    },
    rowActions: {
      allow: 'Goedkeuren',
      decline: 'Afwijzen',
      download: 'Downloaden',
      duplicate: 'Kopiëren',
      invoice: 'Factuur aanmaken',
      preview: 'Bekijken',
    },
  },
  quotationForClient: {
    error: {
      title: 'Fout bij het laden van de offerte.',
    },
  },
  richText: {
    shortcodes: {
      Clientname: 'Klantennaam',
      Freelancerfirstname: 'Voornaam freelancer',
      Quotationlink: 'Offertelink',
    },
  },
};
